<template>
  <v-container>

    <v-row>
      <v-col md="12">
        <h1 class="font-weight-medium">
        <span v-if="$i18n.locale=='es'">{{ participacion.evento.nombre_es }}</span>
                  <span v-else>{{ participacion.evento.nombre_ca }}</span>
        </h1>
                          <h2 class="has-text-danger text-uppercase" style="color:orange" v-if="participacion.evento.state==-1">{{ $t("Cancelado") }}</h2>

      </v-col>
    </v-row>

    <v-row>
      <v-col md="6">

        <pic :evento="participacion.evento"/>

      </v-col>
      <v-col md="6">
        <v-row align="center" v-if="participacion.ok"
               justify="center">
          <v-col md="6">

            <v-checkbox v-model="participacion.sent" color="primary" label="Ya he enviado las muestras">

            </v-checkbox>

          </v-col>
          <v-col md="6">
            <v-btn @click="ok()" color="primary">
              {{ $t('Enviar') }}
            </v-btn>
&nbsp;
            <v-btn :to="'/eventos/subscribir/'+id" color="secondary">
              {{ $t('Editar') }}
            </v-btn>
          </v-col>
        </v-row>

        <direcciones v-if="participacion.ok" :evento="participacion.evento"/>


        <div v-if="!hasPassed && !participacion.ok && participacion.evento.state != -1">
          <v-btn color="primary" large block :to="{name:'subscribe', params:{id:participacion.uuid}}">
            {{ $t('Quiero Inscribirme') }} ({{ $t('Fecha limite') }} {{ participacion.evento.fecha_limite }} )
          </v-btn>
        </div>


        <event-text :evento="participacion.evento"/>


         <div v-if="participacion && participacion.evento.asistir && participacion.evento.state != -1 && !hasPassed">
        <div class="pt-5" v-if="!hasPassed">

          <v-btn @click="showform=true" color="primary" large block>
            {{ $t('Quiero participar como asistente') }}
          </v-btn>
        </div>




        <v-container v-if="showform && !hasPassed">
          <v-row v-for="(p, index) in participacion.participate_person">

            <v-col md="5">
              <v-text-field
                  label="Nombre"
                  v-model="p.nombre"

                  filled
              ></v-text-field>
            </v-col>
            <v-col md="5">
              <v-text-field
                  label="Email"
                  v-model="p.email"

                  filled
              ></v-text-field>
            </v-col>
            <v-col md="1">
              <v-btn color="primary" x-small @click="addPar()">
                +
              </v-btn>
              <v-btn v-if="index > 0" color="primary" x-small @click="remPar()">
                -
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="12">
              <v-btn @click="updatepart" color="primary">{{ $t('Enviar') }}</v-btn>
            </v-col>

          </v-row>
        </v-container>
         </div>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>

import axios from "axios"
import EventText from "@/components/EventText";
import Pic from "@/components/Pic";
import Direcciones from "@/components/Direcciones";

export default {
  components: {Direcciones, Pic, EventText},
  data() {
    return {
      id: null,
      showform: false,
      participacion: {
        evento: {}
      },
      participants: [{
        nombre: "",
        email: ""
      }]
    };
  },
  computed:{
    hasPassed() {
      let now = new Date()
      let today = now.setHours(0,0,0,0);
      let ev = new Date(Date.parse(this.participacion.evento.fecha_limite)).getTime()
      if (  today > ev) {
        return true
      }
      console.log(ev, today)
      return false
    }
  },
  methods: {
    addPar() {
      this.participacion.participate_person.push({nombre: "", email: ""})
    },
    remPar(i) {
      this.participacion.participate_person.splice(i, 1)
    },
    sendPar() {

    },
    ok() {

      const config = {
        method: "patch",
        url: this.$store.state.endpoints.participacion + this.id,
        headers: {Authorization: "Bearer " + this.$store.state.jwt},
        data: {"id": this.id, "sent": this.participacion.sent}
      };
      console.log(config)
      axios(config)
          .then((response) => {
          })
          .catch(error => {
            console.log(error)
          });
    },
    updatepart() {

      const config = {
        method: "patch",
        url: this.$store.state.endpoints.participacion + this.id,
        headers: {Authorization: "Bearer " + this.$store.state.jwt},
        data: {"participate_person": this.participacion.participate_person}
      };
      console.log({"participate_person": this.participacion.participate_person})
      axios(config)
          .then((response) => {
            this.$store.commit("showMessage",{color:"green",content:this.$i18n.t("Guardado")})

          })
          .catch(error => {
            console.log(error)
          });
    }
  },
  created() {
    if (this.$route.params.id) {
      this.id = this.$route.params.id + "/"
      const config = {
        headers: {Authorization: "Bearer " + this.$store.state.jwt},
      };
      axios.get(this.$store.state.endpoints.participacion + this.id, config)
          .then((response) => {
            console.log(response.data)
            this.participacion = response.data

            if(this.participacion.bodega.user != this.$store.state.userid){
              this.$router.push('/');
            }

            //console.log(this.participacion.participate_person.length)
            if (this.participacion.participate_person.length == 0) {
              this.showform = false
              this.participacion.participate_person = [{nombre: "", email: ""}]
            } else {
              this.showform = true
            }

          })
          .catch(error => {
            console.log(error)
          });
    }
  }
}
</script>






